import React, {useState, useEffect} from 'react';
import SourceListItem from './SourceListItem';
import AddingItemPreviewModal from './modals/AddingItemPreviewModal';
import {updateGoogleOzmosysSource} from 'utils/api/entitiesApi';
import {deleteSourceFromEntity} from 'utils/api';
import {toast} from 'react-toastify';

const SourceList = (props) => {
    const {activeEntity, setActiveEntity, handleErrors, preventActions, setPreventActions} = props;
    const [addedSources, setAddedSources] = useState([]);

    // useEffect(() => {
    //     setAddedSources(activeEntity.elements);
    // }, []);

    const deleteSource = async(sourceId) => {
        try {
            if(preventActions) return;
            setPreventActions(true);
            await deleteSourceFromEntity(activeEntity.id, sourceId);
            let activeEntityClone = {...activeEntity};
            let foundSource = activeEntityClone.elements.find(item => item.id === sourceId);
            let index = activeEntityClone.elements.indexOf(foundSource);
            foundSource && activeEntityClone.elements.splice(index, 1);
            setActiveEntity(activeEntityClone);
            setPreventActions(false);
        } catch(err) {
            console.log(err);
            if(err.message && err.message.length < 150) {
                toast.error(err.message);
            }
        }
    };

    const handleSubmitGoogleOzmosysChange = async(sourceId, titleValue, failedCallback) => {
        try {
            // updatingCallback()
            const params = {
                keyword: titleValue,
            };
            const newAlert = await updateGoogleOzmosysSource(activeEntity.id, sourceId, params);
            let activeEntityClone = {...activeEntity};

            let foundSource = activeEntityClone.elements.find(item => item.id === sourceId);
            let index = activeEntityClone.elements.indexOf(foundSource);
            foundSource && activeEntityClone.elements.splice(index, 1);
            newAlert.content.type = 'google_ozmosys';
            activeEntityClone.elements.splice(index, 0, newAlert.content)
            setActiveEntity(activeEntityClone);

            // setSubmitting(false);
            // setEditMode(false);
        } catch(err) {
            console.log(err);
            toast.error('Unable to complete your request at this time')
            failedCallback();
            // handleErrors(err);
            // setSubmitting(false);
        }
    };

    return (
        <div className="w-100">
            {activeEntity.elements && activeEntity.elements.length > 0 && activeEntity.elements.map((source, index) => {
                return (
                    <SourceListItem
                        source={source}
                        index={index}
                        key={source.id ? source.id : source.name ? `${index} + ${source.name}` : index}
                        deleteSource={deleteSource}
                        preventAction={preventActions}
                        // handleErrors={handleErrors}
                        handleSubmitGoogleOzmosysChange={handleSubmitGoogleOzmosysChange}
                        // entityId={activeEntity.id}
                    />
                );
            })}
        </div>
    );
};

export default SourceList;
